var exports = {
  "dropdown": "x24da60e8--61cae8--dropdown",
  "phone": "x24da60e8--61cae8--phone",
  "tablet": "x24da60e8--61cae8--tablet",
  "padded": "x24da60e8--61cae8--padded",
  "label": "x24da60e8--61cae8--label",
};

module.exports = exports;
